import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GrupoService } from '../../../services/grupo.service';
import { SolicitudService } from '../../../services/solicitud.service';
import { DeclaracionService } from '../../../services/declaracion.service';

@Component({
  selector: 'app-administradores',
  templateUrl: './administradores.component.html',
  styleUrls: ['./administradores.component.css'],
  providers: [GrupoService, SolicitudService]
})
export class AdministradoresComponent implements OnInit {

  public identity;
  public token;
  public status;
  public grupo;
  public message_success;
  public message_error;
  public section;
  public solicitues_grupos;
  public solicitues_alta;
  public solicitues_totales;
  public declaraciones_enlinea;
  public declaraciones_opergob;
  public declaraciones_encero;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
    private _solicitudService: SolicitudService,
    private _declaracionService: DeclaracionService
  ) {
    this.identity = this._grupoService.getIdentity();
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {
    if (!this.identity) {
      this._router.navigate(['login']);
    }

    if (this.identity['rol_id'] == '3') {
      this._router.navigate(['login']);
    }

    this.countSolicitudes();
    this.countDeclaraciones();
    this.getGrupo();
    this.getSection();
  }

  getGrupo() {
    this._grupoService.getGrupo(this.token, this.identity['sub']).subscribe(
      response => {
        // Obtener el token 
        if (response.status == 'success') {
          this.grupo = response.grupo;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          this.message_error = error;
        }
      }
    );
  }

  countSolicitudes() {
    this._solicitudService.getCountSolicitudes(this.token).subscribe(
      response => {

        if (response.status == 'success') {
          this.solicitues_grupos = response.grupos;
          this.solicitues_alta = response.altas;
          this.solicitues_totales = response.total;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        }
      }
    );
  }

  countDeclaraciones() {
    this._declaracionService.getCountDeclaraciones(this.token).subscribe(
      response => {

        if (response.status == 'success') {
          this.declaraciones_encero = response.ceros;
          this.declaraciones_opergob = response.opergob;
          this.declaraciones_enlinea = response.linea;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        }
      }
    );
  }

  getSection() {
    this._route.params.subscribe(params => {
      // convertir a entero
      let section = params['section'];
      this.section = section;
    });
  }

}
